import '../../style/index.less'
import './index.less'



// WEBPACK FOOTER //
// ./components/tabs/style/index.js